import React, { useState, useEffect, useRef } from "react";
import Text from "../../common/Text";
import { Link } from "react-router-dom";
import { websiteLink } from "../../../helpers/helpers";
import { useSelector } from "react-redux";
import paths from "../../../constants/paths";

const SubscriptionPlan = ({
  data,
  content,
  plans,
  monthly_plans,
  annual_plans,
  offers,
  subscribed_id,
  is_cancelled,
  subscRef,
  offers_text,
}) => {
  const [open, setOpen] = useState(null);
  const [isAnnual, setIsAnnual] = useState(true);
  const [syncedHeight, setSyncedHeight] = useState(null);

  const activePlans = isAnnual ? annual_plans : monthly_plans;
  const authToken = useSelector((state) => state.fetchSignin.authToken);

  // Ref for measuring height of expanded offer
  const expandedRef = useRef(null);

  useEffect(() => {
    if (expandedRef.current && open) {
      setSyncedHeight(expandedRef.current.scrollHeight);
    } else {
      setSyncedHeight(null);
    }
  }, [open]);

  const togglePricing = () => {
    setIsAnnual(!isAnnual);
  };

  useEffect(() => {
    if (!subscribed_id || !annual_plans || !monthly_plans) return;

    const id = Number(subscribed_id);

    if (id === 3) {
      setIsAnnual(true);
    } else if (id === 1) {
      setIsAnnual(false);
    } else if (annual_plans.some((plan) => Number(plan.id) === id)) {
      setIsAnnual(true);
    } else if (monthly_plans.some((plan) => Number(plan.id) === id)) {
      setIsAnnual(false);
    }
  }, [subscribed_id, annual_plans, monthly_plans]);

  // console.log("is_cancelled", is_cancelled);
  return (
    <>
      <section id="subscription">
        <div className="contain">
          <div className="text-center sub_scription_heading">
            <h2>
              <Text string={content.banner_heading} />
            </h2>
            <p>
              <Text string={content.banner_tagline} />
            </p>
          </div>
          <div className="pricing-container">
            <div className="toggle-wrapper">
              <span className={!isAnnual ? "active-label" : ""}>Monthly</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isAnnual}
                  onChange={togglePricing}
                />
                <span className="slider"></span>
              </label>
              <span className={`d-flex align-items-center gap-3 ${isAnnual ? "active-label" : ""}`}>
                Biannually <em className="featured_job_new2">30% off</em>
              </span>
            </div>
          </div>

          <div className="flex plan_flex">
            {/* First Column (Offers) */}
            <div className="col">
              <ul className="title_sub_lst">
                <li>
                  <h4>
                    <Text string={content.plans_heading} />
                  </h4>
                  <p>
                    <Text string={content.plan_tagline} />
                  </p>
                </li>
                {offers &&
                  offers.map((offer) => {
                    const hasDetails =
                      offer?.details && offer.details.trim() !== "";
                    const isOpen = open === offer.id;

                    return (
                      <li
                        key={offer.id}
                        ref={isOpen ? expandedRef : null}
                        className={
                          hasDetails
                            ? isOpen
                              ? "drop_title_subscription open"
                              : "drop_title_subscription"
                            : ""
                        }
                      >
                        <div
                          className={hasDetails ? "title_top" : ""}
                          onClick={() =>
                            hasDetails && setOpen(isOpen ? null : offer.id)
                          }
                        >
                          {offer.title}
                        </div>
                        {hasDetails && isOpen && (
                          <div className="cntnt_drop">
                            <Text string={offer.details} parse={true} />
                          </div>
                        )}
                      </li>
                    );
                  })}

                <li>
                  <div className="mini_lbl">
                    <span>
                      <Text string={content.cancel_heading} />
                    </span>
                    <Text string={content.cancel_tagline} />
                  </div>
                </li>
              </ul>
            </div>

            {/* Plans Columns */}
            {activePlans && activePlans.length > 0 ? (
              activePlans.map((plan) => (
                <div className="col" key={plan.id}>
                  <ul className="title_sub_lst">
                    <li>
                      {plan.price_per_month > 0 ? (
                        <>
                          <h6>{plan.plan_name}</h6>
                          <h4 className="color">
                            £{plan.price_per_month}
                            <small>/month</small>
                          </h4>
                        </>
                      ) : (
                        <h4 className="color">{plan.plan_name}</h4>
                      )}
                      <p>{plan.tagline}</p>
                    </li>

                    {offers &&
                      offers.map((offer) => {
                        const selected = plan.selected_offers.find(
                          (o) => o.offer_id === offer.id
                        );

                        const isSynced = open === offer.id;

                        return (
                          <li
                            key={offer.id}
                            style={
                              isSynced && syncedHeight
                                ? { minHeight: syncedHeight }
                                : {}
                            }
                            className={isSynced ? "synced-open" : ""}
                          >
                            {selected ? (
                              <div className="green_check_img">
                                <span>
                                  {offer.title}
                                  {offer.details && (
                                    <div className="tooltip">
                                      <img
                                        src={
                                          paths.SITE_BASE_URL +
                                          "/images/info-circle.svg"
                                        }
                                        alt=""
                                        className="tool_icon"
                                      />
                                      <span className="tooltipText">
                                        <Text
                                          string={offer.details}
                                          parse={true}
                                        />
                                      </span>
                                    </div>
                                  )}
                                </span>
                                {!selected.extra_text && (
                                  <img
                                    src="images/new/tick-circle.svg"
                                    alt=""
                                  />
                                )}
                                {selected.extra_text && (
                                  <div className="text_mini">
                                    <p>{selected.extra_text}</p>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="gray_check_img">
                                <span>
                                  {offer.title}
                                  {offer.details && (
                                    <div className="tooltip">
                                      <img
                                        src={
                                          paths.SITE_BASE_URL +
                                          "/images/info-circle.svg"
                                        }
                                        alt=""
                                        className="tool_icon"
                                      />
                                      <span className="tooltipText">
                                        <Text
                                          string={offer.details}
                                          parse={true}
                                        />
                                      </span>
                                    </div>
                                  )}
                                </span>
                                <img src="images/new/close-circle.svg" alt="" />
                              </div>
                            )}
                          </li>
                        );
                      })}

                    <li>
                      <div className="btn_blk">
                        {subscribed_id > 0 ? (
                          is_cancelled ? (
                            subscribed_id == plan.id ? (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`
                                )}
                                className="site_btn blank"
                              >
                                Current Plan
                              </Link>
                            ) : plan.id == 4 || plan.id == 9 ? (
                              <Link to="#" className="site_btn">
                                Select Plan
                              </Link>
                            ) : (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`
                                )}
                                className="site_btn"
                              >
                                Select Plan
                              </Link>
                            )
                          ) : subscribed_id == 2 ? (
                            plan.id == 4 || plan.id == 9 ? (
                              <Link to="#" className="site_btn">
                                Select Plan
                              </Link>
                            ) : (
                              <Link
                                to={websiteLink(
                                  `/subscription-payment/${plan.encoded_id}`
                                )}
                                className="site_btn"
                              >
                                Select Plan
                              </Link>
                            )
                          ) : (
                            <Link
                              to={
                                subscribed_id == plan.id ||
                                (subscribed_id == 1 &&
                                  plan.id ===
                                    (monthly_plans?.[1]?.id || null)) ||
                                (subscribed_id == 3 &&
                                  plan.id === (annual_plans?.[1]?.id || null))
                                  ? "#"
                                  : "#"
                              }
                              className={
                                subscribed_id == plan.id ||
                                (subscribed_id == 1 &&
                                  plan.id ===
                                    (monthly_plans?.[1]?.id || null)) ||
                                (subscribed_id == 3 &&
                                  plan.id === (annual_plans?.[1]?.id || null))
                                  ? "site_btn blank"
                                  : "site_btn"
                              }
                            >
                              {subscribed_id == plan.id ||
                              (subscribed_id == 1 &&
                                plan.id === (monthly_plans?.[1]?.id || null)) ||
                              (subscribed_id == 3 &&
                                plan.id === (annual_plans?.[1]?.id || null))
                                ? "Current Plan"
                                : "Select Plan"}
                            </Link>
                          )
                        ) : (plan.id == 4 || plan.id == 9) && authToken ? (
                          <Link to="#" className="site_btn blank">
                            Current Plan
                          </Link>
                        ) : (
                          <Link
                            to={websiteLink(
                              `/subscription-payment/${plan.encoded_id}`
                            )}
                            className="site_btn"
                          >
                            Select Plan
                          </Link>
                        )}
                      </div>
                    </li>

                    {/* <li>
                      <div className="btn_blk">
                        {subscribed_id > 0 ? (
                          <Link
                            to={subscribed_id == plan.id ? `#` : "#"}
                            className={
                              subscribed_id == plan.id
                                ? "site_btn blank"
                                : "site_btn"
                            }
                          >
                            {subscribed_id == plan.id
                              ? "Current Plan"
                              : "Select Plan"}
                          </Link>
                        ) : (plan.id == 4 || plan.id == 9) && authToken ? (
                          <Link to="#" className="site_btn blank">
                            Current Plan
                          </Link>
                        ) : (
                          <Link
                            to={websiteLink(
                              `/subscription-payment/${plan.encoded_id}`
                            )}
                            className="site_btn"
                          >
                            Select Plan
                          </Link>
                        )}
                      </div>
                    </li> */}
                  </ul>
                </div>
              ))
            ) : (
              <div className="no-plans-message">
                <p>
                  {isAnnual
                    ? "No Annual Plans Available"
                    : "No Monthly Plans Available"}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SubscriptionPlan;
